import { ModulesMap } from '@/config/data/modulesMaps'
import IdentityCardsApi from '@/services/apiServiceModules/identityCardsApi'
import DataTransferModule from '@/services/dataTransferModule'

const identityCardsApi = new IdentityCardsApi()

export default class IdentityCardsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.IDENTITY_CARDS, identityCardsApi, { useCache: true })
	}
}
